module.exports = __webpack_public_path__ + "static/media/S1N6-1.43a1fe0a.svg";